import script from "./addressBookCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./addressBookCard.vue?vue&type=script&lang=ts&setup=true"

import "./addressBookCard.vue?vue&type=style&index=0&id=44402558&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44402558"]])

export default __exports__